import { canvasManager } from "appworks/graphics/canvas/canvas-manager";
import { Sprite } from "appworks/graphics/pixi/sprite";
import { Contract } from "appworks/utils/contracts/contract";
import { Renderer, Texture } from "pixi.js";
class GPUUploader {

    private queue: Upload[] = [];

    public upload(texture: Texture) {
        if (canvasManager.renderer instanceof Renderer) {

            const uploadContract = new Contract<void>((resolve) => {
                this.queue.push({ texture, resolve } as Upload);

                if (this.queue.length === 1) {
                    this.uploadNext();
                }
            });

            return uploadContract;
        } else {
            return Contract.empty();
        }
    }

    private uploadNext() {
        if (this.queue.length) {

            const upload = this.queue.pop();
            const sprite = new Sprite(upload.texture);

            // const ramUsage = Math.floor(((upload.texture.baseTexture.realWidth * upload.texture.baseTexture.realHeight * 4) / (1024 * 1024) * 2) * 100) / 100;
            // console.log("Predicted ram usage: ", upload.texture.baseTexture.textureCacheIds[0], ramUsage + "mb");

            canvasManager.renderer.plugins.prepare.upload(sprite, () => {
                upload.resolve();
                this.uploadNext();
            });
        }
    }

}

interface Upload {
    texture: Texture;
    resolve: () => void;
}

export const gpuUploader = new GPUUploader();
